module.exports = __webpack_public_path__ + "img/avatar.032e5488.png";